export default [
  {
    name: 'Pending Jobs',
    desc: 'List future jobs for Funder Revamp',
    icon: 'exclamation-circle',
    permission: 'listJobs',
    submenu: [
      {
        name: 'Individual',
        link: '/v2/jobs/pending-individual',
        count: 'individual'
      },
      {
        name: 'Recurring Base',
        link: '/v2/jobs/pending-recurring',
        count: 'recurring'
      }
    ]
  },
  {
    name: 'Individual Jobs',
    desc: 'List future jobs for Funder Revamp',
    icon: 'right-circle',
    permission: 'listJobs',
    submenu: [
      {
        name: 'Future Jobs',
        link: '/v2/jobs/future'
      },
      {
        name: 'Past Jobs',
        link: '/v2/jobs/past'
      },
      {
        name: 'Cancelled Jobs',
        link: '/v2/jobs/cancelled'
      }
    ]
  },
  {
    name: 'Recurring Base',
    desc: 'List future jobs for Funder Revamp',
    icon: 'sync',
    permission: 'listJobs',
    submenu: [
      {
        name: 'Active Recurring Base',
        link: '/v2/jobs/recurring'
      },
      {
        name: 'Ended Recurring Base',
        link: '/v2/jobs/recurring-ended'
      }
    ]
  }
]
